import { Type } from 'class-transformer';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { CashReceiptRawDto } from './cash-receipt-raw-dto';

export class CashReceiptEditorResultDto {
    @Type(() => CashReceiptRawDto)
    cashReceipt: CashReceiptRawDto;

    @Type(() => GLAccountSelectorResultDto)
    glAccounts: Array<GLAccountSelectorResultDto>;

    @Type(() => DimensionSelectorResultDto)
    glDimensions: Array<DimensionSelectorResultDto>;

    entityUsesSubcategory: boolean;
    defaultBankName: string;
}
